import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = { // 组件间共享的数据
  baseUrl: 'https://cgi.bbgame.com.tw/v1/area-kr/sgz',
  stopBgChangeCountDown: 202,
  ifShowLoad: true,
  doFastEnd: false,
  playCount: 0, // 预注册总人数
  swiperIsInit: {
    'bottom': false
  },
  circleProgress: {
    'gifts-10wan': false,
    'gifts-30wan': false,
    'gifts-50wan': false
  },
  maskState: {
    'mask': '',
    'nav': false,
    'frame': '',
    'bigFrame': '',
    'video': false,
    'reward': '',
    'content': '',
    'navClass': '',
    'text': '',
    'phone': ''
  },
  pageings: {
    allpage: '',
    current: '',
    currentOne: '',
    showItem: 10,
    paging: []
  },
  userData: {
    'token': '',
    'name': '',
    'email': '',
    'fbID': '',
    'icon': ''
  }
}

const mutations = { // 修改共享数据
  setLoadVisible: (state, val) => {
    if (typeof val === 'boolean') {
      state.ifShowLoad = val
    } else {
      state.doFastEnd = true
    }
  },
  setStopBgChangeCountDown: (state, val) => {
    state.stopBgChangeCountDown = 404
  },
  setSwiperIsInit: (state, item) => {
    state.swiperIsInit[item] = true
  },
  setCircleProgress: (state, value) => {
    state.playCount = value
    if (value >= 500000) {
      state.circleProgress['gifts-50wan'] = true
    }
    if (value >= 300000) {
      state.circleProgress['gifts-30wan'] = true
    }
    if (value >= 100000) {
      state.circleProgress['gifts-10wan'] = true
    }
  },
  setUserData (state, data) {
    let {
      token,
      name,
      email,
      fbID,
      icon
    } = data
    state.userData.token = token
    state.userData.name = name
    state.userData.email = email
    state.userData.fbID = fbID
    state.userData.icon = icon
  },
  clickBtn: function (state, value) {
    let val = value
    if (val) {
      state.maskState['content'] = ''
      if (val[0] === 'bigFrame') {
        state.maskState['text'] = ''
        state.maskState['bigFrame'] = 'active'
        state.maskState['text'] = value['text']
        console.log(value)
      } else if (val['play']) {
        state.maskState['video'] = true
      } else if (!val['flag']) {
        state.maskState['frame'] = 'active'
        state.maskState['content'] = value
      } else {
        let name = value[0]
        state.maskState[name] = value['flag']
      }
      state.maskState['mask'] = 'mask-active'
    } else {
      for (let i in state.maskState) {
        state.maskState[i] = false
      }
      state.maskState['navClass'] = ''
      state.maskState['mask'] = ''
      state.maskState['phone'] = ''
    }
  },
  pageBtn: function (state, value) {
    console.log(value)
    state.pageings['allpage'] = value['allpage']
    state.pageings['current'] = value['current']
    state.pageings['currentOne'] = value['currentOne']
    // eslint-disable-next-line
    state.pageings['paging'] = pagez()

    function pagez () {
      let that = state.pageings
      let pag = []
      if (that.current < that.showItem) { // 如果当前的激活的项 小于要显示的条数
        // 总页数和要显示的条数那个大就显示多少条
        let i = Math.min(that.showItem, that.allpage)
        while (i) {
          pag.unshift(i--)
        }
      } else { // 当前页数大于显示页数了
        let middle = that.current - Math.floor(that.showItem / 2) // 从哪里开始
        let i = that.showItem
        if (middle > (that.allpage - that.showItem)) {
          middle = (that.allpage - that.showItem) + 1
        }
        while (i--) {
          pag.push(middle++)
        }
      }
      return pag
    }
  }
}

const actions = {
  setCircleProgress (context) {
    let _p = context.state.circleProgress
    let _pp = context.getters.getCircleProgress()
    console.log(_p, _pp)
    context.commit('setCircleProgress', 50)
  }
}

const getters = { // 获取共享数据
  getSwiperIsInit: (state, item) => state.swiperIsInit[item],
  getCircleProgress: state => state.circleProgress
}

export default new Vuex.Store({
  getters,
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js